import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';

const DashboardHome: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Simulating data loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-welcome">
        <div className="welcome-header-row">
          <div>
            <h1>Dashboard Overview</h1>
            <p>Welcome to ASW Operations Center. Access quick shortcuts and core management modules.</p>
          </div>
          <div className="system-status-chip">
            <span className="status-indicator-dot"></span>
            <span>System Operational</span>
          </div>
        </div>
      </div>
      
      <div className="dashboard-section main-section">
        <div className="section-header">
          <h2>Quick Actions & Core Modules</h2>
        </div>
        <div className="dashboard-cards">
          <Link to="/dashboard/quotation" className="dashboard-card action-card">
            <div className="card-content">
              <span className="card-icon blue-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="12" y1="18" x2="12" y2="12"></line>
                  <line x1="9" y1="15" x2="15" y2="15"></line>
                </svg>
              </span>
              <h3>Create Quotation</h3>
              <p>Generate vehicle quotation with T-Permit or Private financing</p>
            </div>
          </Link>

          <Link to="/dashboard/quotations" className="dashboard-card action-card">
            <div className="card-content">
              <span className="card-icon emerald-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <line x1="10" y1="9" x2="8" y2="9"></line>
                </svg>
              </span>
              <h3>Manage Quotations</h3>
              <p>Search, review, download PDFs and manage saved quotations</p>
            </div>
          </Link>

          <Link to="/dashboard/cars" className="dashboard-card action-card">
            <div className="card-content">
              <span className="card-icon amber-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9C2.1 11 2 11.5 2 12v4c0 .6.4 1 1 1h2"></path>
                  <circle cx="7" cy="17" r="2"></circle>
                  <path d="M9 17h6"></path>
                  <circle cx="17" cy="17" r="2"></circle>
                </svg>
              </span>
              <h3>Car Inventory</h3>
              <p>Configure commercial T-Permit and personal private models</p>
            </div>
          </Link>

          <Link to="/crm" className="dashboard-card action-card">
            <div className="card-content">
              <span className="card-icon violet-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </span>
              <h3>CRM Portal</h3>
              <p>Track leads, sales executive assignments & follow-ups</p>
            </div>
          </Link>

          <Link to="/dashboard/banners" className="dashboard-card action-card">
            <div className="card-content">
              <span className="card-icon cyan-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
              </span>
              <h3>Banner Management</h3>
              <p>Upload and customize homepage banners & promotional slides</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome; 